
import { computed, defineComponent } from 'vue';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import Icone from '@/core/components/Icone.vue';

export default defineComponent({
  name: 'CampoTelefone',
  components: {
    Icone,
  },
  props: {
    valor: {
      type: String,
      default: '',
    },
    icone: {
      type: String,
      default: 'telefone',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: string) => {
        if (valor === undefined || valor === null) {
          emit('update:valor', '');
        } else {
          emit('update:valor', UtilitarioMascara.removerMascara(valor));
        }
      },
    });

    return {
      props,
      computedValor,
      UtilitarioMascara,
    };
  },
});
